import s from './index.module.css'
import style from '../../index.module.css'
import commonStyle from '../Common/common.module.css'
import { useEffect, useState } from 'react'
import { ButtonDel } from '@UI/Button'
import classNames from 'classnames'
import { nextId } from '../../../../../../helpers/nextId'
import { InputNew, InputFormate } from '../../../../../UI/InputNew'
import { useInputNew } from '../../../../../UI/InputNew/useInputNew'
import { ButtonAdd, ButtonRemove } from '../Common/Buttons'
import CheckboxViolet from '@UI/New/ChecboxViolet/CheckboxViolet'
import Constructor from '@UI/New/Constructor'

export const Omissions = ({ data, edit, setErrorsList, showErrors }) => {
  const [state, setState] = useState(
    data?.answer_options
      ? data?.correct_answer
        ? data.answer_options?.map((item, index) => ({ ...item, ...data?.correct_answer?.find(el => el.index === item.index) ?? { text: '', index: item.index }, devID: index }))
        : data['answer_options']?.map((el, index) => ({ ...el, devID: index }))
      : []
  )

  useEffect(() => {
    const arrCorrect = []

    state?.forEach((el, index) => {
      if (el.text) arrCorrect.push({ text: el.text, type: el.type ?? '', index: index + 1 })
    })

    edit(prev => ({
      ...prev,
      'answer_options': [...state?.map((el, index) => ({ question: el.question, index: index + 1, answer: el.text ? 1 : 0, type: el.type ?? '', fromNewLine: el.fromNewLine ?? 0 }))],
      'correct_answer': arrCorrect
    }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state])

  const onEdit = (text, id) => setState([...state.map(variant => (variant.devID === id) ? { ...variant, text } : variant)])
  const onEditText = (question, id) => setState((prevsState) => [...prevsState.map(variant => (variant.devID === id) ? { ...variant, question } : variant)])

  const onEditType = (type, id) => {
    setState([...state.map(variant => {
      return (variant.devID === id) ? { ...variant, type, text: type === 'constructor' ? [] : '' } : variant
    })])
    
    setErrorsList(prev => {
      const items = { ...prev.items, 
        ...(type === 'constructor' ? {[`${id}_omission_text`]: { value: false }} : {[`${id}_constructor`]: { value: false }})
      };
      let flag = true;
      for (let key in items) {
        if (items[key].value) flag = false;
      }
      return (
        { 
          valid: flag, 
          items 
        }
      )
    })
  }

  const onEditFromNewLine = (fromNewLine, id) => {
    setState([...state.map(variant => {
      return (variant.devID === id) ? { ...variant, fromNewLine } : variant
    })])
  }
  
  const add = () => setState([...state, { text: '', question: '', fromNewLine: 0, devID: nextId(state, 'devID') }])
  const remove = id => {
    setState([...state?.filter(variant => variant.devID !== id)])
    setErrorsList(prev => {
      const items = { ...prev.items, [`${id}_omission`]: { value: false }, [`${id}_constructor`]: { value: false }, [`${id}_omission_text`]: { value: false } };
      let flag = true;
      for (let key in items) {
        if (items[key].value) flag = false;
      }
      return (
        { 
          valid: flag, 
          items 
        }
      )
    })
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { if (!data?.answer_options || data?.answer_options?.length < 1) add() }, [])



  return <div className={s.wrapper}>
    <span className={style.heading}>Задание:</span>
    <div className={s.list}>
      {state?.map((variant, i) =>
        <Item
          key={variant.devID}
          el={variant}
          index={i}
          isLast={state?.length === i + 1}
          remove={() => remove(variant.devID)}
          edit={v => onEdit(v, variant.devID)}
          editText={v => onEditText(v, variant.devID)}
          editType={v => onEditType(v, variant.devID)}
          editFromNewLine = {v => onEditFromNewLine(v, variant.devID)}
          setErrorsList={setErrorsList} showErrors={showErrors} />)}
      <ButtonAdd onClick={add} />
    </div>
  </div>
}

const Item = ({ el, isLast, index, edit, remove, editText, editType, editFromNewLine, setErrorsList, showErrors }) => {
  const [bindName] = useInputNew({
    name: `${el.devID}_omission`,
    value: el?.question,
    onChange: editText,
    onError: setErrorsList,
    placeholder: `Напишите текст задачи до пропуска (${index + 1} часть)`,
    validate: showErrors,
    title: `${index + 1} часть`,
    errorText: index === 0 ? 'Введите текст до пропуска' : 'Удалите или заполните поле',
  })
  const [bindText] = useInputNew({
    title: `${(index + 1)} часть`,
    name: `${el.devID}_omission_text`,
    value: el?.text,
    onChange: edit,
    onError: ((isLast && index !== 0) || el?.type === 'constructor') ? () => { } : setErrorsList,
    placeholder: `Напишите правильный ответ (${index + 1} часть)`,
    validate: ((isLast && index !== 0) || el?.type === 'constructor') ? false : showErrors,
    errorText: index === 0 ? 'Хотя бы один ответ должен присутствовать' : 'Уберите пропуск или заполните поле',
  })
  
  return <div className={s.col}>
    <div className={s.wrapperPart}>
      <InputFormate
        tiptapClassContent={commonStyle.tiptapClassContent}
        tiptapClassContentProseMirror={commonStyle.tiptapClassContentProseMirror}
        className={classNames(style.inputNew, commonStyle.inputFormate)} 
        {...bindName} />
        {
          index !== 0 && (
            <CheckboxViolet
                value={el?.fromNewLine == 1}
                onClick={() => {
                  if(el?.fromNewLine == 1){
                    editFromNewLine(0);
                  }
                  else{
                    editFromNewLine(1)
                  }
                }}
                text='С новой строки'
            />
          )
        }
    </div>
    <div className={s.wrapperPart}>
      {
        el?.type !== 'constructor' && <InputNew classNameForBox={commonStyle.inputBox} className={style.inputNew} {...bindText} />
      }  
      {
        el?.type === 'constructor' && (
          <div className={s.constructorWrapper}>
            <span className={s.constructorTitle}>{(index + 1)} часть</span>
             <Constructor 
              edit={(value) => edit(value)}
              value={el?.text}
              onError={setErrorsList}
              name={`${el.devID}_constructor`}
              validate={showErrors}
            />
          </div>
        )
      }
  
      <CheckboxViolet
          value={el?.type === 'constructor'}
          onClick={() => {
            if(el?.type !== 'constructor'){
              editType('constructor');
            }
            else{
              editType('')
            }
          }}
          text='Конструктор'
      />
    </div>
    
    {index > 0 && <ButtonRemove className={s.btnRemove} onClick={remove} />}
  </div>
}
